import { React, useEffect, useState } from 'react';
import { Link } from "react-router-dom";

import LogoFooter from '../../composents/Logo/NavbarLogo/Logo';
import MentionsLegalesModal from '../Constants/MentionsLegalesModal';

const Footer = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [mentionsLegalesOpened, setMentionsLegalesOpened] = useState(false);

    useEffect(() => {
        window.scrollTo(0,0);
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
          };
          window.addEventListener('resize', handleResize);
          return () => {
            window.removeEventListener('resize', handleResize);
          };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return(
        <div className="footer">
            {isMobile ? (
                <>
                    <div className="footer-align">
                        <LogoFooter/>
                        <div className="vertical jStart"> 
                            <div><h6 className='mrgT20 mrgB10 mrgR20 txt20'>Informations</h6></div>
                            <div>
                                <div id="publicOpenedMLGa4" className='noMrgT mrgB7 mrgR20 txt13 bT' style={{ cursor: 'pointer' }} onClick={() => setMentionsLegalesOpened(true)}>
                                    Mentions légales
                                </div>
                            </div>
                            {/* <div>
                                <a href="https://res.cloudinary.com/do9t6jjdy/image/upload/v1693765220/LPG002_Conditions_G%C3%A9n%C3%A9rales_d_Utilisation_v.2_0923_idmckv.pdf" target="_blank" rel="noreferrer">
                                    <div id="publicOpenedCGUGa4" className='noMrgT mrgB7 mrgL40 mrgR20'>
                                        Conditions générales d'utilisation
                                    </div>
                                </a>
                            </div> */}
                            {/* <div>
                                <a href="https://res.cloudinary.com/do9t6jjdy/image/upload/v1702889743/RGPD-P-001_-_Politique_de_confidentialit%C3%A9_v.3_1223_gcrwbv.pdf" target="_blank" rel="noreferrer">
                                    <div id="publicOpenedRGPDGa4" className='noMrgT mrgB7 mrgR20'>
                                        Confidentialité
                                    </div>
                                </a>
                            </div> */}
                        </div>

                        <div>
                            <Link to="/">
                                <div><h6 className='mrgT20 mrgB10 mrgR20 txt20'>Contact</h6></div>
                            </Link>
                            <a href="mailto:contact@boldee.co">
                                <div className='noMrgT mrgB7 mrgR20 txt13'>contact@boldee.co</div>
                            </a>
                        </div>
                    </div>
                    <div><p>© Copyright 2026 Boldee</p></div>
                </>
            ) : (
                <>
                    <div className="footer-align">
                        <LogoFooter/>
                        <div className="vertical jStart"> 
                            <div><h6 className='mrgT20 mrgB10 mrgL40 mrgR20 txt20'>Informations</h6></div>
                            <div>
                                <div id="publicOpenedMLGa4" className='noMrgT mrgB7 mrgL40 mrgR20 bT' style={{ cursor: 'pointer' }} onClick={() => setMentionsLegalesOpened(true)}>
                                   <span className='noMrgTB txt16'>Mentions légales</span>
                                </div>
                            </div>
                            {/* <div>
                                <a href="https://res.cloudinary.com/do9t6jjdy/image/upload/v1693765220/LPG002_Conditions_G%C3%A9n%C3%A9rales_d_Utilisation_v.2_0923_idmckv.pdf" target="_blank" rel="noreferrer">
                                    <div id="publicOpenedCGUGa4" className='noMrgT mrgB7 mrgL40 mrgR20'>
                                        Conditions générales d'utilisation
                                    </div>
                                </a>
                            </div> */}
                            {/* <div>
                                <a href="https://res.cloudinary.com/do9t6jjdy/image/upload/v1702889743/RGPD-P-001_-_Politique_de_confidentialit%C3%A9_v.3_1223_gcrwbv.pdf" target="_blank" rel="noreferrer">
                                    <div id="publicOpenedRGPDGa4" className='noMrgT mrgB7 mrgL40 mrgR20'>
                                        Confidentialité
                                    </div>
                                </a>
                            </div> */}
                        </div>

                        <div className='leftBorder'>
                            <Link to="/">
                                <div><h6 className='mrgT20 mrgB10 mrgL40 mrgR20 txt20'>Contact</h6></div>
                            </Link>
                            <a href="mailto:contact@boldee.co">
                                <div className='noMrgT mrgB7 mrgL40 mrgR20'>
                                    <span className='txt16'>contact@boldee.co</span>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div><p>© Copyright 2026 Boldee</p></div>
                </>
            )}
            <MentionsLegalesModal opened={mentionsLegalesOpened} onClose={() => setMentionsLegalesOpened(false)} />
        </div>
        );
}


export default Footer;

